import React from 'react';

export default ({ color = '#FFF', size = 18 }: { color?: string, size?: number }): JSX.Element => (
  <svg width={size} height={size} viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.30013 0.800781H15.6751C16.0663 0.800781 16.3835 1.13657 16.3835 1.55078V6.42578C16.3835 6.84 16.0663 7.17578 15.6751 7.17578H10.7168L8.5918 9.05078V1.55078C8.5918 1.13657 8.90892 0.800781 9.30013 0.800781Z"
      stroke={color}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.34245 13.5469C2.38666 13.5469 0.800781 15.2467 0.800781 17.2969H7.88411C7.88411 15.2467 6.29823 13.5469 4.34245 13.5469Z"
      stroke={color}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.3431 11.3008C5.3211 11.3008 6.11393 10.4613 6.11393 9.42578C6.11393 8.39026 5.3211 7.55078 4.3431 7.55078C3.3651 7.55078 2.57227 8.39026 2.57227 9.42578C2.57227 10.4613 3.3651 11.3008 4.3431 11.3008Z"
      stroke={color}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.0723 4.17455L12.0561 5.21622L14.2597 2.88281"
      stroke={color}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
